<template lang="pug">
.promo-footer
  PromosFooterSocial(v-if="isShowSocial")
  .promo-footer__main
    GradientDecor.promo-footer__decor(:colorDecor="colorDecor", :colorBg="colorBg")
    .promo-footer__content
      PromosFooterTerms
      PromosFooterLegal(:copyright="$t('footer.copyright')", :logos="getLogos")
</template>

<script>
import GradientDecor from "@battle_teams_2_components/components/gradient-decor/vue/GradientDecor";
import PromosFooterTerms from "./blocks/PromosFooterTerms";
import PromosFooterLegal from "./blocks/PromosFooterLegal";
import PromosFooterSocial from "./blocks/PromosFooterSocial";

export default {
  name: "PromosFooter",

  components: {
    GradientDecor,
    PromosFooterTerms,
    PromosFooterLegal,
    PromosFooterSocial,
  },

  props: {
    isShowSocial: {
      type: Boolean,
      default: true,
    },
    colorDecor: {
      type: String,
      default: "1f1f1f",
    },
    colorBg: {
      type: String,
      default: "",
    },
  },

  computed: {
    getLogos() {
      return [
        {
          image:
            require("@chronos/battle-teams-2-components/src/components/footer/images/logo_astrum.svg"),
          id: "astrum",
          link: "https://astrum-entertainment.ru/",
        },
        {
          image:
            require("@chronos/battle-teams-2-components/src/components/footer/images/logo_vkplay.svg"),
          id: "vkplay",
          link: "https://vkplay.ru",
        },
        {
          image:
            require("@chronos/battle-teams-2-components/src/components/footer/images/logo_wizardgames.svg"),
          id: "wizardgames",
          link: "https://www.wooduan.com/",
        },
      ];
    },
  },

  created() {
    document.addEventListener("init_vue_components", () => {
      this.$store.dispatch("terms/getTermsInfo");
    });
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/promo-footer";
</style>
